module.exports = __webpack_public_path__ + "img/relacionamento.59b49971.png";